import React from 'react';
import type { ComparisonFeature } from '@sy/ssr-types';
import { CompetitorLogo } from '../CompetitorLogos';
import type { CompetitorType } from '../../types';
import FeatureCard from './components/FeatureCard';
import {
	Container,
	Header,
	StreamYardLogoWrapper,
	StyledStreamYardLogo,
	CompetitorLogoWrapper,
	CompetitorLogoText,
	Row,
	MobileStreamYardLogoWrapper,
	MobileStyledLogo,
	StyledDivider,
} from './ComparisonColumns.styled';

interface ComparisonColumnsProps {
	competitor: CompetitorType;
	fullCompetitorName?: string;
	features: ComparisonFeature[];
}

const ComparisonColumns: React.FC<ComparisonColumnsProps> = ({
	competitor,
	fullCompetitorName,
	features,
}) => {
	return (
		<Container>
			<Header>
				<StreamYardLogoWrapper>
					<StyledStreamYardLogo />
				</StreamYardLogoWrapper>
				<CompetitorLogoWrapper>
					<CompetitorLogo competitor={competitor} size={50} />
					<CompetitorLogoText>
						{fullCompetitorName || competitor}
					</CompetitorLogoText>
				</CompetitorLogoWrapper>
			</Header>

			{features.map((feature, index) => (
				<Row key={index}>
					<FeatureCard
						isCompetitor={false}
						competitor={competitor}
						feature={feature.streamyard}
						logo={
							<MobileStreamYardLogoWrapper>
								<MobileStyledLogo variant="icon" />
							</MobileStreamYardLogoWrapper>
						}
					/>
					<StyledDivider />
					<FeatureCard
						isCompetitor={true}
						competitor={competitor}
						feature={feature.competitor}
						logo={<CompetitorLogo competitor={competitor} size={40} />}
					/>
				</Row>
			))}
		</Container>
	);
};

export default ComparisonColumns;
